import LTMain from "./LTGame/Start/LTMain";
import MainStart from "./script/MainStart";
new LTMain(MainStart);
